export const handlePayments = async (products, address) => {
  const res = await axios({
    method: 'POST',
    url: '/api/v1/orders/create-order',
    data: {
      products,
      address,
    },
  });

  if (res.data.status !== 'success') {
    console.error('Error creating order:', res.data);
    return;
  }

  // ✅ Extract data correctly
  const { razorpayOrderId, orderId, amount, currency } = res.data.data;

  // ✅ Check if Razorpay is loaded
  if (typeof Razorpay === 'undefined') {
    console.error('Razorpay SDK not loaded');
    return;
  }

  // ✅ Razorpay Initialization
  const options = {
    key: 'rzp_live_PRAUF1VEuH3ozx', // ⚠️ Replace with actual Razorpay Key
    amount: amount,
    currency: currency,
    name: 'AnanyaSales',
    description: 'Order Payment',
    order_id: razorpayOrderId, // ✅ This is the correct order ID from Razorpay
    handler: async function (response) {
      // Step 3: Verify Payment with backend
      const verifyRes = await fetch('/api/v1/orders/payment-success', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          razorpay_order_id: razorpayOrderId, // ✅ Use correct key names
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        }),
      });

      const verifyData = await verifyRes.json();

      if (verifyData.status === 'success') {
        alert('Payment Successful!');
        window.setTimeout(() => location.assign(`/account`), 1500);
      } else {
        alert('Payment Failed!');
      }
    },
    theme: { color: '#3399cc' },
  };

  const rzp = new Razorpay(options);
  rzp.open();
};
